var map = {
	"./al.svg": 49705,
	"./at.svg": 31969,
	"./ba.svg": 53637,
	"./be.svg": 60649,
	"./bg.svg": 23979,
	"./ch.svg": 43023,
	"./cn.svg": 40353,
	"./cy.svg": 97678,
	"./cz.svg": 8397,
	"./de.svg": 41203,
	"./dk.svg": 80677,
	"./ee.svg": 50324,
	"./es.svg": 67162,
	"./fi.svg": 59369,
	"./fr.svg": 36594,
	"./gb.svg": 89217,
	"./gr.svg": 88721,
	"./hr.svg": 9352,
	"./hu.svg": 11751,
	"./ie.svg": 56936,
	"./it.svg": 87625,
	"./jp.svg": 52252,
	"./kp.svg": 20479,
	"./kr.svg": 44845,
	"./lt.svg": 57498,
	"./lu.svg": 72107,
	"./lv.svg": 21368,
	"./mc.svg": 1362,
	"./mt.svg": 51149,
	"./nl.svg": 79900,
	"./no.svg": 82223,
	"./pl.svg": 81670,
	"./pt.svg": 24414,
	"./ro.svg": 64803,
	"./rs.svg": 27735,
	"./ru.svg": 42793,
	"./se.svg": 69210,
	"./si.svg": 590,
	"./sk.svg": 36204,
	"./tr.svg": 89676,
	"./ua.svg": 60344,
	"./us.svg": 76010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22370;